import { useDatasheetPurchases } from "@/lib/datasheets";

export function PurchasesSection({ datasheetId }: { datasheetId: number }) {
  const { data, isLoading } = useDatasheetPurchases(datasheetId);

  if (isLoading) return <p className="text-sm text-muted-foreground">Loading…</p>;
  if (!data || data.length === 0) {
    return <p className="text-sm text-muted-foreground">No purchases or adjustments recorded.</p>;
  }

  return (
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b text-left">
          <th className="py-2">Date</th>
          <th>Type</th>
          <th>Reference</th>
          <th className="text-right">Quantities</th>
        </tr>
      </thead>
      <tbody>
        {data.map((p) => (
          <tr key={p.datasheetPurchaseId} className="border-b last:border-0">
            <td className="py-2">{new Date(p.purchaseDate).toLocaleDateString()}</td>
            <td>{p.isAdjustment ? "Adjustment" : "Purchase"}</td>
            <td>{p.adjustmentDesc ?? p.clientPurchaseOrderNo ?? "—"}</td>
            <td className="text-right">{p.sizeQuantities.filter((q) => q !== 0).join(", ") || "—"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
